import axios from 'axios';
import { store } from '../store';
import config from '../config/index';
import { Device } from '@twilio/voice-sdk';
import emitter from '../util/emitter';

let call;
const TwilioService = {
  async getToken({ shortCode }) {
    const { loginReducer } = store.getState();
    const { token } = loginReducer;

    const response = await axios.get(`${config.apiUrl}/${shortCode}/twilio/token`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  },
  async dialNumber(
    token,
    phoneNumber,
    opts = {
      primaryContact: 'unknown',
      customerName: 'unknown',
      countryCode: 'GB',
      contactId: null,
      shortCode: null,
      task: null,
    },
  ) {
    if (!phoneNumber) throw new Error('No phone numbers provided');

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    window.localStream = stream;

    const device = new Device(token);

    if (call) call.disconnect();

    call = await device.connect({
      params: {
        To: phoneNumber,
        Country: opts.countryCode,
        organisationShortCode: opts.shortCode,
        ContactID: opts.contactId,
      },
      rtcConstraints: {
        audio: true,
      },
    });

    call.on('accept', call => {
      emitter.emit('acceptCall', { ...opts, callId: call.parameters.CallSid });
    });
    call.on('disconnect', () => emitter.emit('disconnectCall', opts));
    call.on('cancelCall', () => emitter.emit('cancelCall'));

    return call;
  },
  async disconnectCall() {
    if (call) {
      call.disconnect();
      window.localStream.getTracks()[0].stop();
    }
  },
  async sendDigits(digits) {
    if (call) {
      call.sendDigits(digits);
    } else {
      throw new Error('No active call to send digits');
    }
  },
  async handleRecording({
    shortCode,
    startRecording = false,
    stopRecording = false,
    callId,
    recordingSid,
  }) {
    const { loginReducer } = store.getState();
    const { token } = loginReducer;

    const response = await axios({
      method: 'post',
      url: `${config.apiUrl}/${shortCode}/twilio/recording`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        startRecording,
        stopRecording,
        callId,
        recordingSid,
      },
    });

    return response.data;
  },
  async getRecording({ shortCode, recordingId }) {
    const { loginReducer } = store.getState();
    const { token } = loginReducer;

    const response = await axios({
      method: 'post',
      url: `${config.apiUrl}/${shortCode}/twilio/recordingUrl`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        recordingId,
      },
    });

    return response.data;
  },
};

export default TwilioService;
